import { format, Locale } from 'date-fns';

/**
 * The default formatter for the caption.
 */
export function formatCaption(
  month: Date,
  options?: { locale?: Locale }
): string {
  return format(month, 'LLLL y', options);
}
